import React, { Component } from 'react';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import InstrumentFunctions from '../services/InstrumentService';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import { MdClear } from 'react-icons/md';
import '../layout/site.css';
//import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CalsCertsFunctions from '../services/CalsCertsService';
import Select from 'react-dropdown-select';
import Moment from 'react-moment';

export class ScheduleOnSite extends Component {

    static displayName = ScheduleOnSite.name;

    constructor(props) {
        super(props);

        this.state = {
            siteList: [],
            client: null,
            search: null,
            fromDate: '',
            toDate: '',
            instruments: [],
            instrumentsOrig: [],
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            showToast: false,
            showRequestOnSite: false,
            show: false,
            description: '',
            mte: '',
            model: '',
            manufacturer: '',
            range: '',
            newIndex: 0,
            poNum: '',
            fileUpload: null,
            notes: '',
            useCC: 'No'
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSelectClick = this.handleSelectClick.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCheckAll = this.handleCheckAll.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.handleAddNew = this.handleAddNew.bind(this);
        this.handleAddNewItem = this.handleAddNewItem.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async getCalibrations() {
        var calibrations = await CalsCertsFunctions.getCalibrationsAsync();

        if (calibrations.success == true) {
            if (calibrations.data != null) {
                var original = calibrations.data;
                var filtered = original.slice(0);
                this.setState({ instruments: filtered, instrumentsOrig: original });
            }
        }

    }

    handleCheckAll(event) {
        var instruments = this.state.instruments;
        var checked = event.target.checked;

        instruments.forEach((instrument, index) => {
            if (!instrument.delete == true)
                instrument.selected = checked;
        });

        this.setState({ instruments: instruments });
    }

    handleSelectClick(event, partNo) {
        this.handleCheck(event.target.checked, partNo);
    }

    handleDeleteClick(event, partNo, newIndex) {
        this.handleDelete(event.target.checked, partNo, newIndex);
    }

    handleCheck(checked, partNo, newIndex) {
        var instruments = this.state.instruments;

        if (partNo == 'New' && newIndex != undefined && newIndex != null) {
            var filtered = instruments.filter(function (instrument) {
                return instrument.newIndex == newIndex;
            });

            if (filtered.length > 0) {
                filtered[0].selected = checked;
            }
        } else {
            var filtered = instruments.filter(function (instrument) {
                return instrument.partNo == partNo;
            });

            if (filtered.length > 0) {
                filtered[0].selected = checked;
            }
        }

        this.setState({ instruments: instruments });
    }

    handleDelete(checked, partNo, newIndex) {
        var instruments = this.state.instruments;

        if (partNo == 'New' && newIndex != undefined && newIndex != null) {
            instruments = instruments.filter(function (instrument) {
                return instrument.newIndex != newIndex;
            });
        }
        else {
            var filtered = instruments.filter(function (instrument) {
                return instrument.partNo == partNo;
            });

            if (filtered.length > 0) {
                filtered[0].delete = checked;
            }
        }
        this.setState({ instruments: instruments });
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.instruments.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleClose() {
        this.setState({ show: false, showToast: false, showRequestOnSite: false });
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.instruments.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.instruments.length / pageSize) })
        }
    }

    async handleSubmission() {
        this.setState({ showRequestOnSite: false });

        const formData = new FormData();

        formData.append('File', this.state.fileUpload);
        formData.append('PONum', this.state.poNum);
        formData.append('UseCC', this.state.useCC);
        formData.append('Notes', this.state.notes);

        var selected = this.state.instrumentsOrig.filter(function (instrument) {
            return (instrument.delete == true || instrument.selected == true);
        });

        formData.append('Data', JSON.stringify(selected));

        var response = await InstrumentFunctions.postOnSiteScheduleUploadAsync(formData);

        if (response != null) {
            this.setState({ showToast: true });
        }
    };

    handleAddNew() {
        this.setState({ show: true });
    };

    handleOpenRequest() {
        this.setState({ poNum: '', notes: '', useCC: 'No', showRequestOnSite: true });
    }

    handleAddNewItem() {
        var description = this.state.description;
        var mte = this.state.mte;
        var model = this.state.model;
        var manufacturer = this.state.manufacturer;
        var range = this.state.range;
        var newIndex = this.state.newIndex + 1;

        var original = this.state.instrumentsOrig;
        original.unshift({ newIndex: newIndex, partNo: 'New', mte: mte, model: model, description: description, range: range, manufacturer: manufacturer, selected: true, delete: false });
        this.setState({ description: '', mte: '', model: '', manufacturer: '', range: '', newIndex: newIndex });
        this.setState({ instrumentsOrig: original });
        this.setState({ show: false });
        this.searchInstruments();
    };

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        //this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
        this.getCalibrations();
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchInstruments();
        }
    }

    render() {
        // Logic for displaying instruments!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.instruments.slice(indexOfFirstItem, indexOfLastItem);
        //const [show, setShow] = Component(false);

        const selectedItems = this.state.instruments.filter(function (instrument) {
            return instrument.selected != null && instrument.selected == true;
        }).map((instrument) =>
            ({ label: instrument.partNo + ' - ' + instrument.description, value: instrument.partNo, newIndex: instrument.newIndex })
        ).sort(function (a, b) {
            return (a.value.localeCompare(b.value));
        });

        //const deletedItems = this.state.instruments.filter(function (instrument) {
        //    return instrument.delete != null && instrument.delete == true;
        //}).map((instrument) =>
        //    ({ label: instrument.partNo + ' - ' + instrument.description, value: instrument.partNo, newIndex: instrument.newIndex })
        //).sort(function (a, b) {
        //    return (a.value.localeCompare(b.value));
        //});

        const addedItems = this.state.instruments.filter(function (instrument) {
            return instrument.partNo == 'New';
        }).map((instrument) =>
            ({ label: instrument.partNo + ' - ' + instrument.description, value: instrument.partNo, newIndex: instrument.newIndex })
        ).sort(function (a, b) {
            return (a.value.localeCompare(b.value));
        });

        const customContentRenderer = () => {
            return (
                <div>{selectedItems.length} Instruments Selected</div>
            );
        }

        const customNoDataRenderer = () => {
            return (
                <div>0 Instruments Selected</div>
            );
        }

        const customDeletedContentRenderer = () => {
            return (
                <div>{addedItems.length} Instruments Added</div>
            );
        }

        const customDeletedNoDataRenderer = () => {
            return (
                <div>0 Instruments Added</div>
            );
        }

        const customItemRenderer = ({ item, itemIndex, props, state, methods }) => (
            <div style={{ width: '100%' }}>
                <div style={{ padding: '5px', float: 'left' }}>
                    {item.label}
                </div>
                <div style={{ padding: '5px', float: 'right' }}>
                    <MdClear
                        onClick={() => this.handleCheck(false, item.value, item.newIndex)}
                        color={'#0a58ca'}
                    />
                </div>
            </div>
        );

        const customDeletedItemRenderer = ({ item, itemIndex, props, state, methods }) => (
            <div style={{ width: '100%' }}>
                <div style={{ padding: '5px', float: 'left' }}>
                    {item.label}
                </div>
                <div style={{ padding: '5px', float: 'right' }}>
                    <MdClear
                        onClick={() => this.handleDelete(false, item.value, item.newIndex)}
                        color={'#0a58ca'}
                    />
                </div>
            </div>
        );

        const renderItems = currentItems.map((instrument, i) => {
            return (
                <tr key={i}>
                    {/*<td className='noBanner centerCheckBoxTD'>*/}
                    {/*    <Input*/}
                    {/*        type='checkbox'*/}
                    {/*        onChange={(e) => this.handleDeleteClick(e, instrument.partNo, instrument.newIndex)}*/}
                    {/*        checked={instrument.delete}*/}
                    {/*        disabled={instrument.selected == true}*/}
                    {/*        className='centerCheckBoxInput'*/}
                    {/*    />*/}
                    {/*</td>*/}
                    <td className='noBanner centerCheckBoxTD'>
                        <Input
                            type='checkbox'
                            onChange={(e) => this.handleSelectClick(e, instrument.partNo)}
                            checked={instrument.selected}
                            disabled={instrument.delete == true}
                            className='centerCheckBoxInput'
                        />
                    </td>
                    <td>{instrument.partNo}</td>
                    <td>{instrument.mte}</td>
                    <td>{instrument.expDate != null && <Moment format="M/D/YY">{instrument.expDate}</Moment>}</td>
                    <td>{instrument.description}</td>
                </tr>
            )
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.instruments.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{ color: '#233c7c' }}>Schedule On-Site</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row>
                                <div className='col' style={{ maxWidth: '185px' }}></div>
                                <div className='col' style={{ maxWidth: '200px' }}>From Date</div>
                                <div className='col' style={{ maxWidth: '200px' }}>To Date</div>
                            </Row>
                            <Row>
                                <div className='col' style={{ maxWidth: '185px' }}>
                                    <Input
                                        type='text'
                                        style={{ width: '175px' }}
                                        onChange={(e) => this.setState({ search: e.target.value })}
                                        name='search'
                                        id='search'
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='Enter R#, M&TE#'
                                    />
                                </div>
                                <div className='col' style={{ maxWidth: '200px' }}>
                                    <Input
                                        type='date'
                                        onChange={(e) => this.setState({ fromDate: e.target.value })}
                                        name='DateFrom'
                                        id='DateFrom'
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='From Date'
                                    />
                                </div>
                                <div className='col' style={{ maxWidth: '200px' }}>
                                    <Input
                                        type='date'
                                        onChange={(e) => this.setState({ toDate: e.target.value })}
                                        name='DateTo'
                                        id='DateTo'
                                        className='fullInput'
                                        onKeyPress={this.handleKeyPress}
                                        placeholder='To Date'
                                    />
                                </div>
                                <div className='col' style={{ maxWidth: '125px' }}>
                                    <Button
                                        color='primary'
                                        style={{ width: '125px' }}
                                        className='standardButton fullInput'
                                        onClick={() => this.searchInstruments()}
                                        disabled={this.state.loading ? true : false}
                                    >
                                        Search
                                    </Button>
                                </div>
                                <div className='col' style={{ textAlign: 'right' }}>
                                    <Button
                                        color='primary'
                                        className='standardButton fullInput'
                                        onClick={() => this.handleAddNew()}
                                        style={{ width: '250px' }}
                                        disabled={this.state.loading ? true : false}
                                    >
                                        Add New Item
                                    </Button>
                                </div>
                            </Row>
                            <Row>
                                <div className='col'>
                                    <Select
                                        style={{ borderRadius: '0.25rem' }}
                                        className='fullInput'
                                        placeholder=""
                                        noDataRenderer={customNoDataRenderer}
                                        contentRenderer={customContentRenderer}
                                        itemRenderer={customItemRenderer}
                                        onChange={() => undefined}
                                        values={selectedItems}
                                        loading={this.state.loading}
                                        options={selectedItems}
                                    />
                                </div>
                                <div className='col' style={{ textAlign: 'right' }}>
                                    <Button
                                        color='primary'
                                        className='standardButton marginTop'
                                        onClick={() => this.handleOpenRequest()}
                                        style={{ width: '250px' }}
                                        disabled={this.state.loading ? true : false}
                                    >
                                        Request Onsite Schedule
                                    </Button>
                                </div>
                            </Row>

                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <div className='col'>
                            <Select
                                className='form-control'
                                style={{ borderRadius: '0.25rem' }}
                                placeholder=""
                                noDataRenderer={customDeletedNoDataRenderer}
                                contentRenderer={customDeletedContentRenderer}
                                itemRenderer={customDeletedItemRenderer}
                                onChange={() => undefined}
                                values={addedItems}
                                loading={this.state.loading}
                                options={addedItems}
                            />
                        </div>
                        <div className='col'>
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </Row>
                    <Row style={{ marginTop: '20px' }}>
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className='noBanner centerCheckBoxTD'>
                                            <div>
                                                <Input
                                                    type='checkbox'
                                                    onChange={(e) => this.handleCheckAll(e)} //Call a function to check all the checkboxes.
                                                    className='centerCheckBoxInput fullInput'
                                                />
                                            </div>

                                        </th>
                                        <th>
                                            R#
                                            <FaSort
                                                color={this.state.sort.column === 'partNo' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('partNo')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            M&TE#
                                            <FaSort
                                                color={this.state.sort.column === 'mte' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('mte')}
                                                className='sort-button'
                                            />
                                        </th>


                                        <th>
                                            Date Due
                                            <FaSort
                                                color={this.state.sort.column === 'expDate' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('expDate')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Tool Description
                                            <FaSort
                                                color={this.state.sort.column === 'description' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('description')}
                                                className='sort-button'
                                            />
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.loading === true && this.state.loadingDocument === false ? (
                                        <tr>
                                            <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                <Spinner color="primary" children='' />
                                            </td>
                                        </tr>

                                    ) : (
                                        <>
                                            {!this.state.noResults ? (
                                                <>
                                                    {renderItems}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                        <h5>No Results Found</h5>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {this.state.instruments.length !== 0 && (
                        <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px', marginBottom: '50px' }}>
                            <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                {renderPageNumbers}
                            </select>
                            <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                            <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>

                        </div>
                    )}
                </Container>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header >
                        <Modal.Title>New Item</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Col>
                            <Row>
                                <Input
                                    type='text'
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                    name='ToolDescription'
                                    id='ToolDescription'
                                    className='fullInput'
                                    value={this.state.description}
                                    placeholder='Tool Description'
                                />
                            </Row>
                            <Row>
                                <Input
                                    type='text'
                                    onChange={(e) => this.setState({ mte: e.target.value })}
                                    name='MnTE'
                                    id='MnTE'
                                    className='fullInput'
                                    value={this.state.mte}
                                    placeholder='M&TE#'
                                />
                            </Row>
                            <Row>
                                <Input
                                    type='text'
                                    onChange={(e) => this.setState({ model: e.target.value })}
                                    name='ModelNum'
                                    id='ModelNum'
                                    className='fullInput'
                                    value={this.state.model}
                                    placeholder='Model #'
                                />
                            </Row>
                            <Row>
                                <Input
                                    type='text'
                                    onChange={(e) => this.setState({ manufacturer: e.target.value })}
                                    name='Manufacturer'
                                    id='Manufacturer'
                                    className='fullInput'
                                    value={this.state.manufacturer}
                                    placeholder='Manufacturer'
                                />
                            </Row>
                            <Row>
                                <Input
                                    type='text'
                                    onChange={(e) => this.setState({ range: e.target.value })}
                                    name='Range'
                                    id='Range'
                                    className='fullInput'
                                    value={this.state.range}
                                    placeholder='Range'
                                />
                            </Row>
                        </Col>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="standardButton btn btn-primary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" className="standardButton btn btn-primary" onClick={this.handleAddNewItem}>
                            Add Item
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showToast} onHide={this.handleClose}>
                    <Modal.Header >
                        <Modal.Title>Email Sent!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Thank you for requesting a quote for calibration.  A <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team member is working on your quote.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showRequestOnSite} onHide={this.handleClose}>
                    <Modal.Header >
                        <Modal.Title>Request Onsite Schedule</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Col>
                            <Row>
                                <Input
                                    type='text'
                                    name='poNum'
                                    id='poNum'
                                    onChange={(e) => this.setState({ poNum: e.target.value })}
                                    placeholder='PO #'
                                />
                            </Row>
                            <Row className='row-10'>
                                <label>
                                    <Input
                                        type='checkbox'
                                        onChange={(e) => this.setState({ useCC: e.target.checked ? 'Yes' : 'No' })}
                                        name='useCC'
                                        id='useCC'
                                        className='fullInput'
                                        value={this.state.useCC == 'Yes'}
                                        placeholder='Use CC'
                                        style={{ marginTop: '5px' }}
                                    />
                                    Pay with credit card?
                                </label>
                            </Row>
                            <Row>
                                <Input
                                    type='file'
                                    onChange={(e) => this.setState({ fileUpload: e.target.files[0] })}
                                    name='fileUpload'
                                    id='fileUpload'
                                    style={{ display: 'inline-block', marginTop: '10px' }}
                                    placeholder='Upload'
                                />
                            </Row>
                            <Row className='row-10'>
                                <textarea
                                    className='form-control marginTop'
                                    name='Message'
                                    id='Message'
                                    onChange={(e) => this.setState({ notes: e.target.value })}
                                    placeholder='Notes To TIC-MS'
                                />
                            </Row>

                        </Col>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="standardButton btn btn-primary" onClick={(e) => this.handleClose()}>
                            Close
                        </Button>
                        <Button variant="primary" className="standardButton btn btn-primary" onClick={(e) => this.handleSubmission()}>
                            Request Onsite Schedule
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    // instruments

    async searchInstruments() {
        var search = this.state.search;
        var fromDate = this.state.fromDate;
        var toDate = this.state.toDate;
        var instruments = this.state.instrumentsOrig;

        if (search !== null && search !== "") {
            instruments = instruments.filter(function (instrument) {
                return instrument.partNo.includes(search);
            });
            instruments = instruments.filter(function (instrument) {
                return instrument.mte.includes(search);
            });
        }
        if (fromDate !== null && fromDate !== '') {
            var from = new Date(fromDate);
            instruments = instruments.filter(function (instrument) {
                var expDate = new Date(instrument.expDate);
                return (expDate.getTime() >= from.getTime());
            });
        }
        if (toDate !== null && toDate !== '') {
            var to = new Date(toDate);
            var endOfDay = 24 * 60 * 60 * 1000;
            instruments = instruments.filter(function (instrument) {
                var expDate = new Date(instrument.expDate);
                return (expDate.getTime() <= to.getTime() + endOfDay);
            });
        }

        this.setState({ instruments: instruments });

    }

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.instruments;

        data.sort(function (a, b) {
            if (!a[column]) return -1;

            if (!b[column]) return +1;

            return (a[column] instanceof Date ? (b[column] - a[column]) : a[column].localeCompare(b[column]));
        });

        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            instruments: data,
            sort: {
                column,
                direction
            }
        })
    }
}